import { render, staticRenderFns } from "./CustomDefinedField.vue?vue&type=template&id=1d5976f0&scoped=true"
import script from "./CustomDefinedField.vue?vue&type=script&lang=ts"
export * from "./CustomDefinedField.vue?vue&type=script&lang=ts"
import style0 from "./CustomDefinedField.vue?vue&type=style&index=0&id=1d5976f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5976f0",
  null
  
)

export default component.exports